var render = function (_h,_vm) {var _c=_vm._c;return _c('font-awesome-icon',{staticClass:"icon-file",class:{
    'icon-file-active': _vm.props.active
  },attrs:{"icon":"file-alt"}})}
var staticRenderFns = []

export { render, staticRenderFns }